import { Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Store } from '@ngrx/store';
import { LocationService } from 'src/app/admin/location/shared/services/location.service';
import { State } from 'src/app/dashboard/state';
import { LocationsDropDownCheckBoxTreeViewComponent } from 'src/app/shared/modalpopup/locations-drop-down-treeview/locations-drop-down-check-box-tree-view-component';

import { LocationUsersDropDownModel } from '../../models/users-drop-down-list.model';

@Component({
  selector: 'app-user-selector',
  templateUrl: './user-selector.component.html',
  styleUrls: ['./user-selector.component.scss']
})
export class UserSelectorComponent implements OnInit {

  public checkedLocationIds: number[] = [-1];
  public userLocationIds: number[] = [-1];
  public expandedKeys: any[] = ["-1"];

  public selectorOpened: boolean = false;
  public disableSelector: boolean = false;

  @Input() dispatchStateEvent: boolean = true;

  @Input() selectedUserName: string = "Select";
  @Input() selectedUserId: number = 0;

  @Input() hoverText: string = '';

  @Input() isIncludeFloatLocation: boolean = true;
  @Input() isDisableParentClick: boolean = false;
  @Input() page: string = "";
  @Input() hideBranchLess: boolean = false;

  // get checked components Tree view unique id
  @Input() selectItem: any = { name: 'Select', id: -1 };

  /**
   * Selected value
   */
  public selectedValue = { name: 'Select', id: -1 };
  @Input() selectorDisabled: boolean = false;

  @Output() onChange: EventEmitter<LocationUsersDropDownModel> = new EventEmitter();
  //@Output() onLocationsData = new EventEmitter<LocationSelector>();

  public locations: LocationUsersDropDownModel[] = [];

  @ViewChild(LocationsDropDownCheckBoxTreeViewComponent) locationsDropDownCheckBoxTreeViewComponent?: LocationsDropDownCheckBoxTreeViewComponent;
  constructor(private locationService: LocationService,
    private elementRef: ElementRef,
    private store: Store<State>) { }

  ngOnInit(): void {

    this.selectedValue = this.selectItem;

    this.locationService.getNestedLocationUserHierarchy()//this.isDisableParentClick, this.isIncludeFloatLocation,this.hideBranchLess)
      .subscribe((response: LocationUsersDropDownModel[]) => {
        this.locations = response;
      });

    this.setDropDownState();
  }

  private setDropDownState() {
    this.disableSelector = this.selectorDisabled;
  }

  @HostListener('document:mousedown', ['$event'])
  onGlobalClick(event: Event): void {
    if (!this.elementRef.nativeElement.contains(event.target)) {
      // clicked outside => close dropdown list
      this.selectorOpened = false;
    }
  }

  public closeDropDown() {
    this.selectorOpened = false;
  }

  public onItemSelected(data: LocationUsersDropDownModel) {
    this.selectorOpened = false;
    this.onChange.emit(data);
  }

  private addExpandListItem(treeItem: LocationUsersDropDownModel[]) {
    treeItem.forEach(item => {
      if (item.items && item.items.length > 0) {
        this.expandedKeys.push(item.locationId);
        this.addExpandListItem(item.items)
      }
    });
  }

  public locationClick() {
    if (!this.selectorDisabled) {
      this.selectorOpened = !this.selectorOpened;
    }
  }

}

